import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PtUiAppRoutes } from '@pt/pt-models';
import { ChangePasswordComponent } from './features/pages/change-password.component';
import { DashboardComponent } from './features/pages/dashboard.component';
import { LoadingComponent } from './features/pages/loading.component';
import { ForbiddenComponent } from './features/pages/forbidden.component';
import {
  AuthGuardService,
  DebugGuardService,
  ForbiddenGuardService,
} from '@pt/pt-core';
import { WorkspaceGuardService } from './services/workspace-guard.service';
import { GenericReportFormComponent } from './features/pages/generic-report-form.component';
import { ForbiddenModuleComponent } from './features/pages/forbidden-module.component';
import { OauthComponent } from './features/pages/oauth.component';
import { MfaComponent } from './features/pages/mfa.component';

const DEFAULT_PATH = PtUiAppRoutes.HOME;

const routes: Routes = [
  { path: '', redirectTo: DEFAULT_PATH, pathMatch: 'full' },
  {
    path: PtUiAppRoutes.DEBUG,
    canActivate: [DebugGuardService],
    loadChildren: () =>
      import('./features/debug/debug.module').then((m) => m.DebugModule),
  },
  {
    path: PtUiAppRoutes.LOGIN,
    loadChildren: () =>
      import('./features/login/login-ui.module').then((m) => m.LoginUiModule),
  },
  {
    path: PtUiAppRoutes.LOADER,
    component: LoadingComponent,
  },
  {
    path: PtUiAppRoutes.OAUTH, //PtUiAppRoutes.OAUTH, // = /oauth
    component: OauthComponent,
  },
  {
    path: PtUiAppRoutes.FORBIDDEN,
    component: ForbiddenComponent,
    canActivate: [ForbiddenGuardService],
  },
  {
    path: PtUiAppRoutes.FORBIDDEN_MODULE,
    component: ForbiddenModuleComponent,
  },
  {
    path: PtUiAppRoutes.CHANGE_PASSWORD,
    component: ChangePasswordComponent,
  },
  // used on develop for test generic reports
  {
    path: PtUiAppRoutes.GENERIC_REPORT,
    component: GenericReportFormComponent,
  },
  {
    path: '',
    component: DashboardComponent,
    children: [
      {
        path: PtUiAppRoutes.HOME,
        loadChildren: () =>
          import('./features/home/home.module').then((m) => m.HomeModule),
        data: {
          breadcrumb: 'SIDEBAR.HOME',
        },
        canActivate: [AuthGuardService],
      },
      {
        path: PtUiAppRoutes.REMINDER,
        loadChildren: () =>
          import('./features/home/domains/reminder/reminder.module').then(
            (m) => m.ReminderModule
          ),
        canActivate: [AuthGuardService],
        data: {
          breadcrumb: 'SIDEBAR.REMINDER',
        },
      },
      {
        path: PtUiAppRoutes.WORKSPACE,
        loadChildren: () =>
          import('./features/home/domains/workspace/workspace.module').then(
            (t) => t.WorkspaceModule
          ),
        data: {
          breadcrumb: 'SIDEBAR.WORKSPACE',
        },
        canActivate: [AuthGuardService, WorkspaceGuardService],
      },
      {
        path: PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE,
        loadChildren: () =>
          import(
            './features/home/domains/data-protection-governance/data-protection-governance.module'
          ).then((m) => m.DataProtectionGovernanceModule),
        data: {
          breadcrumb: 'SIDEBAR.DATA_PROTECTION_GOVERNANCE',
        },
        canActivate: [AuthGuardService],
      },
      {
        path: PtUiAppRoutes.BUSINESS_MANAGEMENT,
        loadChildren: () =>
          import(
            './features/home/domains/business-project-management/business-project-management.module'
          ).then((m) => m.BusinessProjectManagementModule),
        data: {
          breadcrumb: 'SIDEBAR.BUSINESS_MANAGEMENT',
        },
        canActivate: [AuthGuardService],
      },
      {
        path: PtUiAppRoutes.PROFILE,

        loadChildren: () =>
          import('./features/home/domains/profile/profile.module').then(
            (m) => m.ProfileModule
          ),
        data: {
          breadcrumb: 'SIDEBAR.PROFILE',
        },
        canActivate: [AuthGuardService],
      },
      {
        path: PtUiAppRoutes.DATA_BREACHES,
        loadChildren: () =>
          import(
            './features/home/domains/data-breaches/data-breaches.module'
          ).then((m) => m.DataBreachesModule),
        data: {
          breadcrumb: 'SIDEBAR.DATA_BREACHES',
        },
        canActivate: [AuthGuardService],
      },
      {
        path: PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION,
        loadChildren: () =>
          import('./features/administrator/administrator.module').then(
            (m) => m.AdministratorModule
          ),
        canActivate: [AuthGuardService],
        data: {
          breadcrumb: 'SIDEBAR.ADMINISTRATION_AND_CONFIGURATION',
        },
      },
    ],
  },
  {
    path: PtUiAppRoutes.MFA,
    component: MfaComponent,
  },
  {
    path: '**',
    redirectTo: DEFAULT_PATH,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
